import { dataSimples } from '../../lib/datas'
import { TEXTOS } from '../../lib/glossario'
import type { LinhaPorDia } from '../../types/repositorios'

/**
 * Os commits de cada dia, em barras.
 *
 * Barra em CSS, e não biblioteca de gráfico, pela mesma razão da série de indicadores: são até
 * trinta e um retângulos com uma altura calculada. O número vai escrito em cima e a leitura
 * acessível vai no `aria-label` — a barra é complemento, nunca a única forma de ler o dado.
 *
 * @param props as linhas por dia, já em ordem
 * @returns as barras
 */
export function AtividadePorDia({ linhas }: { linhas: LinhaPorDia[] }) {
  const t = TEXTOS.repositorios
  if (linhas.length < 2) {
    return null
  }
  const maior = Math.max(...linhas.map((l) => l.commits + l.integracoes), 1)

  return (
    <section className="cartao p-4" aria-label={t.secoes.dias}>
      <h2 className="text-base font-semibold text-slate-900">{t.secoes.dias}</h2>
      <ol className="mt-4 flex items-end gap-1 overflow-x-auto pb-1">
        {linhas.map((linha) => {
          const total = linha.commits + linha.integracoes
          return (
            <li key={linha.dia} className="flex min-w-9 flex-1 flex-col items-center gap-1">
              <span className="text-xs font-semibold tabular-nums text-slate-900">{total}</span>
              <div className="flex h-20 w-full items-end rounded bg-slate-100" aria-hidden="true">
                <div
                  className="w-full rounded bg-niteroi-600"
                  style={{ height: `${Math.max(4, Math.round((100 * total) / maior))}%` }}
                />
              </div>
              <span
                role="img"
                aria-label={`${dataSimples(linha.dia)}: ${linha.commits} ${t.numeros.commits.toLowerCase()}, ${linha.integracoes} ${t.numeros.integracoes.toLowerCase()}`}
                className="text-center text-xs text-slate-600"
              >
                {linha.dia.slice(8, 10)}
              </span>
            </li>
          )
        })}
      </ol>
    </section>
  )
}
